import { MessageBar, MessageBarType } from "@fluentui/react";
import React, { memo } from "react";
import { localize } from "src/utils/l10n";

interface Props {
    errorList: string[];
    onDismiss?: () => void;
    style?: React.CSSProperties;
    actions?: any;
    title?: string;
    messageBarType?: MessageBarType;
}

export default memo(function ErrorMessagebar(props: Props) {
    const { errorList, onDismiss, actions, title, messageBarType } = props;

    return (
        <div className="ErrorMessagebar" role="alert" style={props.style}>
            <MessageBar
                dismissButtonAriaLabel="Close"
                onDismiss={onDismiss}
                messageBarType={!!messageBarType ? messageBarType : MessageBarType.error}
                isMultiline={true}
                actions={actions}
            >
                {
                    !!title && title
                }
                {
                    !title && (localize("Fel") + ":")
                }
                {errorList.map((err, i) => {
                    return <div key={i}>{localize(err)}</div>;
                })}
            </MessageBar>
        </div>
    );
});
